<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataForm.addLoading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading" v-if="!page.isNew">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/visitantes">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Nome" v-model="dataset.data.name" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Email" v-model="dataset.data.email" required
                                                :rules="[$rules.required, $rules.email]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-select dense label="Tipo de acesso" v-model="dataset.data.access_type"
                                                :items="dataset.accessTypes" item-text="name" item-value="id"
                                                required outlined hide-details="auto" :rules="[$rules.required]">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-select dense label="Status" v-model="dataset.data.status"
                                                :items="dataset.statuses" item-text="name" item-value="id"
                                                required outlined hide-details="auto" :rules="[$rules.required]">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense label="Empresa" v-model="dataset.data.company_name"
                                                outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>


                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="CPF" v-model="dataset.data.registration" required
                                                :rules="[$rules.required, $rules.cpf]" v-mask="$masks.cpf" outlined
                                                hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Permitir entrada a partir de" type="datetime-local"
                                                v-model="dataset.data.access_start_at" outlined
                                                hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Permitir entrada até" type="datetime-local"
                                                v-model="dataset.data.access_end_at" required outlined
                                                hide-details="auto" :rules="[$rules.required]">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Responsável interno" v-model="dataset.data.host_name"
                                                outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field dense label="Motivo" v-model="dataset.data.reason"
                                                outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <v-file-input dense accept="image/png, image/jpeg" prepend-icon="" outlined
                                                counter :rules="[$rules.fileSize(2)]"
                                                hint="O arquivo não pode ser superior a 2MB" hide-details="auto"
                                                label="Imagem" :clearable="true" @change="onFileSelected($event)"
                                                ref="file">
                                            </v-file-input>

                                            <v-img v-if="dataset.data.document_url"
                                                @click="openDoc(dataset.data.document_url)" class="rounded-xl"
                                                :height="100" :width="100" :src="dataset.data.document_url">
                                            </v-img>

                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col>
                                            <p class="font-weight-bold">Descrição referente ao acesso</p>
                                            <tiptap-vuetify class="custom-editor-long"
                                                v-model="dataset.data.description" :rules="[$rules.required]"
                                                :extensions="extensions" hide-details="auto" />
                                        </v-col>
                                    </v-row>

                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <v-card class="card-form-outlined">
                        <v-row align="center">
                            <v-col>
                                <v-card-title class="card-group-title">Endereço</v-card-title>
                            </v-col>
                        </v-row>

                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="2">
                                    <v-text-field dense label="CEP" v-model="dataset.data.address_postal_code" required
                                        :rules="[$rules.required]" v-mask="$masks.zipCode" outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" @click="loadZipcodeData()">Buscar</v-btn>
                                        </template>
                                        <span>Buscar endereço</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="10">
                                    <v-text-field dense label="Rua" v-model="dataset.data.address_street" required
                                        :rules="[$rules.required]" outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-text-field dense label="Número" v-model="dataset.data.address_number" outlined
                                        hide-details="auto">
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field dense label="Bairro" v-model="dataset.data.address_district" required
                                        :rules="[$rules.required]" outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-text-field disabled readonly dense label="Cidade"
                                        v-model="dataset.data.address_city" required :rules="[$rules.required]" outlined
                                        hide-details="auto">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" sm="2">
                                    <v-select disabled readonly no-data-text="Nenhuma UF encontrada" dense
                                        :items="dataset.states" label="UF" v-model="dataset.data.address_state"
                                        item-value="acronym" item-text="acronym" outlined :rules="[$rules.required]"
                                        required hide-details="auto">
                                    </v-select>
                                </v-col>

                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

        </v-form>

        <v-dialog v-model="dialogViewDoc" max-width="60%">
            <v-card>
                <v-img :src="selectedDoc" alt="" contain />
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>

import string from "@/common/util/string"
import axios from "axios"
import states from "@/common/data/states.data"
import { eventHub } from "@/main";

import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Paragraph
} from 'tiptap-vuetify'

export default {
    name: "GuestDetails",
    components: {
        'tiptap-vuetify': TiptapVuetify,
    },

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            breadcrumbItems: [],
            data: {
                access_type: 'visitor',
                status: 'active',
            },
            states: states,
            accessTypes: [
                { id: 'visitor', name: 'Visitante' },
                { id: 'service_provider', name: 'Prestador de serviço' },
            ],
            statuses: [
                { id: 'active', name: 'Ativo' },
                { id: 'inactive', name: 'Inativo' },
            ],
            modalResult: null,
        },

        extensions: [
            Underline,
            Strike,
            Italic,
            Bold,
            Paragraph,
        ],

        selectedDoc: null,
        dialogViewDoc: false,
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },

    }),

    created() {
        this.loadData();
    },

    methods: {
        goBack() {
            this.$router.replace("/visitantes");
        },

        openDoc(cover) {
            this.selectedDoc = cover;
            this.dialogViewDoc = true;
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();
            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `${this.page.isNew ? 'Novo visitante' : 'Detalhes do visitante'}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Visitantes",
                disabled: false,
                to: "/visitantes",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/v1/guests/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = {
                    ...data,
                    access_start_at: this.toDateTimeLocal(data.access_start_at),
                    access_end_at: this.toDateTimeLocal(data.access_end_at || data.access_end_date),
                };

                this.dataset.students = data.students

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },


        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o visitante?',
                title: 'Incluir visitante',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/v1/guests', payload);

                this.$dialog.notify.info("Visitante salvo com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados do visitante?',
                title: 'Atualizar visitante',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.updateLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/v1/guests/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Visitante salvo com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.updateLoading = false;
            }
        },

        onFileSelected(file) {
            this.dataset.data.file = file;
        },

        toDateTimeLocal(value) {
            if (!value) return null;

            const date = new Date(value);
            if (Number.isNaN(date.getTime())) return value;

            const pad = (item) => `${item}`.padStart(2, '0');

            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
        },

        buildPayload() {
            const formData = new FormData()

            if (this.dataset.data.name)
                formData.append('name', this.dataset.data.name);

            if (this.dataset.data.email)
                formData.append('email', this.dataset.data.email);

            if (this.dataset.data.registration)
                formData.append('registration', this.dataset.data.registration);

            if (this.dataset.data.access_type)
                formData.append('access_type', this.dataset.data.access_type);

            if (this.dataset.data.status)
                formData.append('status', this.dataset.data.status);

            if (this.dataset.data.company_name)
                formData.append('company_name', this.dataset.data.company_name);

            if (this.dataset.data.host_name)
                formData.append('host_name', this.dataset.data.host_name);

            if (this.dataset.data.reason)
                formData.append('reason', this.dataset.data.reason);

            if (this.dataset.data.access_start_at)
                formData.append('access_start_at', this.dataset.data.access_start_at);

            if (this.dataset.data.access_end_at)
                formData.append('access_end_at', this.dataset.data.access_end_at);

            if (this.dataset.data.description)
                formData.append('description', this.dataset.data.description);

            if (this.dataset.data.address_street)
                formData.append('address_street', this.dataset.data.address_street);

            if (this.dataset.data.address_number)
                formData.append('address_number', this.dataset.data.address_number);

            if (this.dataset.data.address_district)
                formData.append('address_district', this.dataset.data.address_district);

            if (this.dataset.data.address_postal_code)
                formData.append('address_postal_code', this.dataset.data.address_postal_code);

            if (this.dataset.data.address_state)
                formData.append('address_state', this.dataset.data.address_state);

            if (this.dataset.data.address_city)
                formData.append('address_city', this.dataset.data.address_city);

            if (this.dataset.data.file)
                formData.append('document', this.dataset.data.file)

            return formData;
        },


        async loadZipcodeData() {

            if (!this.dataset.data.address_postal_code) {

                this.$dialog.notify.error("O campo CEP deve ser preenchido!", { position: "top-right", timeout: 3000 });

                return

            }

            const zipcode = string.sanitizeZipcode(this.dataset.data.address_postal_code)

            try {
                const result = await axios.get(`/api/v1/address/${zipcode}`);

                const resultData = result.data.content;

                const state = this.dataset.states.find((x) => x.acronym == resultData.state) || null

                console.log('state ', state, this.dataset.states)

                const data = {
                    address_street: resultData.street,
                    address_district: resultData.district,
                    address_state: state ? state.acronym : null,
                    address_city: resultData.city
                }

                this.dataset.data = { ...this.dataset.data, ...data }

            } catch (error) {
                console.log(error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
